<template>
	<el-dialog
		class="good_dialog"
		:class="{ 'is-mobile-dialog': isMobile }"
		custom-class="good_dialog_panel"
		:visible.sync="innerVisible"
		:fullscreen="isMobile"
		:show-close="false"
		:append-to-body="true"
		:close-on-click-modal="!isMobile"
		:z-index="zIndex"
		v-dialog-drag="{ handle: '.good_dialog_drag', disabled: isMobile }"
		@update:visible="onVisible">
		<div class="good_dialog_body">
			<div v-if="!isMobile" class="good_dialog_drag" title="拖动窗口">
				<i class="el-icon-rank"></i>
				<span>添加产品</span>
			</div>
			<div v-if="isMobile" class="qm-picker-bar">
				<span class="qm-picker-bar__title">添加产品</span>
				<button type="button" class="qm-picker-bar__close" @click.stop.prevent="$emit('close')">关闭</button>
			</div>
			<el-row type="flex" align="middle" class="list_header">
				<el-row type="flex" align="middle" class="search_box">
					<el-input
						@keyup.enter.native="$emit('search')"
						class="search_input"
						placeholder="搜索产品名称 / 关键词"
						:value="search"
						clearable
						@input="$emit('update:search', $event)"></el-input>
					<el-row type="flex" align="middle" justify="center" class="search_img">
						<img src="../../assets/img/search.png" />
					</el-row>
					<div @click="$emit('search')" class="search_btn" title="搜索"></div>
				</el-row>
				<el-select @change="onTypeChange" class="list_type" :value="typeIndex" placeholder="选择分类">
					<el-option v-for="(item,index) in types" :key="index" :label="item.name" :value="index">
					</el-option>
				</el-select>
				<button v-if="!isMobile" type="button" class="good_dialog_close" title="关闭" @click="$emit('close')">
					<i class="el-icon-close"></i>
				</button>
			</el-row>
			<div class="good_list_wrap">
				<div v-if="isMobile" class="qm-picker-list">
					<div v-if="!goodList.length" class="qm-empty">暂无产品</div>
					<p v-else class="qm-picker-hint">点选产品进入详情</p>
					<button
						v-for="item in goodList"
						:key="item.id"
						type="button"
						class="qm-picker-item"
						@click.prevent="$emit('choose', item)"
						@dblclick.prevent="$emit('choose', item)">
						<div class="qm-picker-item__img">
							<el-image fit="contain" :src="item.image">
								<div slot="error" class="image-slot">
									<i class="el-icon-picture-outline"></i>
								</div>
							</el-image>
						</div>
						<div class="qm-picker-item__body">
							<div class="qm-picker-item__name">{{ item.name }}</div>
							<div v-if="item.summary" class="qm-picker-item__summary">{{ item.summary }}</div>
						</div>
					</button>
				</div>
				<el-table
					v-else
					highlight-current-row
					ref="goodTable"
					@row-dblclick="$emit('choose', $event)"
					@row-click="$emit('row-click', $event)"
					@current-change="$emit('current-change', $event)"
					:data="goodList"
					class="good_list"
					cell-class-name="good_text"
					header-cell-class-name="good_header">
					<el-table-column :resizable="resizeable" align="center" width="110" label="图片">
						<template slot-scope="scope">
							<el-row type="flex" justify="center" align="middle" class="good_img">
								<el-image fit="contain" :src="scope.row.image">
									<div slot="error" class="image-slot">
										<i class="el-icon-picture-outline"></i>
									</div>
								</el-image>
							</el-row>
						</template>
					</el-table-column>
					<el-table-column
						:resizable="resizeable"
						header-align="center"
						align="left"
						:min-width="nameMinWidth"
						prop="name"
						label="产品名称"
						:show-overflow-tooltip="nameTooltip">
						<template v-if="!nameTooltip" slot-scope="scope">
							<div class="good_name_text">{{ scope.row.name }}</div>
						</template>
					</el-table-column>
					<el-table-column
						:resizable="resizeable"
						header-align="center"
						align="left"
						:min-width="summaryMinWidth"
						prop="summary"
						label="概述"
						:show-overflow-tooltip="nameTooltip">
						<template v-if="!nameTooltip" slot-scope="scope">
							<div class="good_summary_text">{{ scope.row.summary }}</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</el-dialog>
</template>

<script>
	import dialogDrag from '@/directives/dialog-drag'

	export default {
		name: 'GoodPickerDialog',
		directives: { dialogDrag },
		props: {
			visible: { type: Boolean, default: false },
			isMobile: { type: Boolean, default: false },
			search: { type: String, default: '' },
			types: { type: Array, default: function() { return [] } },
			typeIndex: { type: [Number, String], default: 0 },
			goodList: { type: Array, default: function() { return [] } },
			resizeable: { type: Boolean, default: false },
			zIndex: { type: Number, default: undefined },
			nameMinWidth: { type: [Number, String], default: 180 },
			summaryMinWidth: { type: [Number, String], default: 220 },
			nameTooltip: { type: Boolean, default: false },
		},
		computed: {
			innerVisible: {
				get() { return this.visible },
				set(val) { this.$emit('update:visible', val) },
			},
		},
		methods: {
			onVisible(val) {
				this.$emit('update:visible', val)
			},
			onTypeChange(val) {
				this.$emit('update:typeIndex', val)
				this.$emit('change-type', val)
			},
		},
	}
</script>
